import { useMemo } from 'react';

import { Carousel, Flex } from '@myphx-engineering/phx-design-system';
import { getCurrentOs, usePwaContext, usePwaFlags } from '@phx/pwa';

import { useSwipeableViews } from '../../../hooks/use-swipeable-views';

import { AddContactCard } from './AddContactCard';
import { AddToHomeCard } from './AddToHomeCard';

const userOs = getCurrentOs();

export const MarketingCards = () => {
    const { flags } = usePwaFlags('lilly');
    const { addToContacts, addToHome } = flags;
    const { canInstall, isInstalled } = usePwaContext();

    const cards = useMemo(() => {
        const arr = [];

        if (userOs === 'desktop') {
            return null;
        }

        if (!addToContacts) {
            arr.push(<AddContactCard key="add-contact" />);
        }

        if (!addToHome && canInstall && !isInstalled) {
            arr.push(<AddToHomeCard key="add-home" />);
        }

        return arr;
    }, [addToContacts, addToHome, canInstall, isInstalled]);

    const useSwipe = useSwipeableViews(cards);

    if (!cards || cards.length === 0) {
        return null;
    }

    if (useSwipe) {
        return (
            <Carousel
                cropped
                slides={cards}
                indicatorOffset="var(--mantine-spacing-xxs)"
            />
        );
    }

    return <Flex gap="xs">{cards.map((card) => card)}</Flex>;
};
